module.exports = __webpack_public_path__ + "img/co.25eb5ec5.svg";